import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './uploadedFilesDisplay.html?raw';
import { EmailEditorTypes } from "../emailTypes";
import { HtmlHelpers } from "../../../more/Helpers";
import _WidgetBaseSP from 'more/_WidgetBaseSP';

class email_UploadedFilesDisplay extends compose(_WidgetBaseSP) {
    templateString: any = template;

    fileBtnRow: HTMLDivElement;

    fileRecord: Record<string, { filename: string, iconClass: string }> = {};

    mainContainer: HTMLDivElement;

    postCreate() {
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public getRecordState() {
        return this.fileRecord;
    }

    public setRecordState(newFR: any) {
        this.fileRecord = newFR;
        this.render_file_buttons();
    }

    public addFileButton(filename: string, fileID: string) {
        let iconClass = "far fa-file-alt";
        let fileExt = "";
        if (filename.split(".").length > 1) {
            fileExt = filename.split(".")[filename.split(".").length - 1];
        }
        //zuweisung icon nach file extension
        const fileExtensions: Record<string, string[]> = {
            "far fa-file-archive": ["zip", "rar", "7z", "tar", "gz", "bz2", "xz", "iso", "dmg", "tgz", "tbz2", "tar.gz", "tar.bz2", "tar.xz", "cab", "jar", "war", "ear", "ace", "arj", "lzh"],
            "far fa-file-word": ["doc", "docx", "dot", "dotx", "docm", "dotm", "rtf"],
            "far fa-file-image": ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "svg"],
            "far fa-file-pdf": ["pdf"],
            "far fa-file-audio": ["mp3", "wav", "ogg", "flac", "aac", "m4a"],
            "fas fa-file-csv": ["csv"],
            "far fa-file-video": ["mp4", "avi", "mkv", "mov", "wmv", "flv", "m4v", "mpeg", "3gp"],
        };
        let skipLoop = false;
        for (let icon in fileExtensions) {
            for (let knownExtension of fileExtensions[icon]) {
                if (fileExt.toLowerCase() == knownExtension.toLowerCase()) {
                    iconClass = icon;
                    skipLoop = true;
                    break;
                }
            }
            if (skipLoop == true) {
                break;
            }
        }

        //#############################
        this.fileRecord[fileID] = { filename: filename, iconClass: iconClass };
        this.render_file_buttons();
        this.emit("newFile", { guid: fileID, filename: filename } as EmailEditorTypes.MailDataFile);
    }

    private _removeFileButtons(fileID: string) {
        delete this.fileRecord[fileID];
        this.render_file_buttons();
        this.emit("removedFile", fileID);
    }

    //private _onMouseEnter_fileBtn(ev:Event){
    //    let targetID = (ev.target as HTMLButtonElement).getAttribute("fileID");
    //    if ((typeof targetID != 'undefined') && (targetID != null) && (targetID != "")){
    //        let targetIco = this.fileBtnRow.querySelector("i[fileID=\"" + targetID + "\"]");
    //        if (typeof targetIco != 'undefined'){
    //            targetIco.setAttribute("class", "far fa-trash-alt");
    //        }
    //    }
    //}
    //private _onMouseLeave_fileButton(ev: Event) {
    //    let targetID = (ev.target as HTMLButtonElement).getAttribute("fileID");
    //    if ((typeof targetID != 'undefined') && (targetID != null) && (targetID != "")) {
    //        let targetIco = this.fileBtnRow.querySelector("i[fileID=\"" + targetID + "\"]");
    //        if (typeof targetIco != 'undefined') {
    //            try{
    //                targetIco.setAttribute("class", this.fileRecord[targetID].iconClass);
    //            }catch{
    //                //webkit my beloved <3
    //            }
    //        }
    //    }
    //}

    private _onClick_RemoveFile(fileID: string, ev: Event) {
        let targetID = fileID; // (ev.target as HTMLButtonElement).getAttribute("fileID");
        this._removeFileButtons(targetID);
    }

    public resetUploadDisplay() {
        this.fileRecord = {};
        this.UiModder.domConstruct.empty(this.fileBtnRow);
    }
    private render_file_buttons() {
        this.UiModder.domConstruct.empty(this.fileBtnRow);
        //this.hideNode(this.fileBtnRow);

        for (let key in this.fileRecord) {
            let fileID = key;
            let filename = this.fileRecord[key].filename;
            let iconClass = this.fileRecord[key].iconClass;

            let fileContainer = this.UiModder.domConstruct.create("div", {
                className: "attachment tertiaryBG  flex_row_center nowrap w3-round",
                title: filename
            }, this.fileBtnRow);




            //for (let newCl of "padding mds-button-base hoverBright sL4 rounder".split(" ")){
            //    newBtn.classList.add(newCl);
            //}
            //if (document.body.classList.contains("darkTheme") == true){
            //    newBtn.classList.remove("sL4");
            //    newBtn.classList.add("sD4");
            //}
            //newBtn.style.margin = "2px";




            let titleElement = this.UiModder.domConstruct.create("span", {
                className: "filename paddingSmall",
                innerHTML: filename
            }, fileContainer);

            let icon = HtmlHelpers.createFontawesomeIcon(iconClass, "right", titleElement);

            let removeBtn = this.UiModder.domConstruct.create("button", {
                className: "removeAttachmentButton deleteBtn mds-button-base hoverBright",
                title: filename + " " + this.translate("email_mailForm_FileUploaderMenu_File_Delete_ToolTip")
            }, fileContainer);

            HtmlHelpers.createFontawesomeIcon("fas fa-times", false, removeBtn);

            //let newTxtSPan = document.createElement("span");
            //newTxtSPan.style.paddingLeft = "5px";
            //newTxtSPan.innerHTML = filename;
            ////newTxtSPan.style.color = "var(--dark)";

            removeBtn.setAttribute("fileID", fileID);
            icon.setAttribute("fileID", fileID);
            titleElement.setAttribute("fileID", fileID);

            //fileBtn.appendChild(icon);
            //fileBtn.appendChild(titleElement);

            //this.fileBtnRow.appendChild(fileBtn);
            //button events
            //fileBtn.addEventListener("mouseenter", lang.hitch(this, this._onMouseEnter_fileBtn));
            //fileBtn.addEventListener("mouseleave", lang.hitch(this, this._onMouseLeave_fileButton));
            removeBtn.addEventListener("click", lang.hitch(this, this._onClick_RemoveFile, fileID));
        }


    }
}

export default mdsWidget(email_UploadedFilesDisplay);
